// Produktkarten: „Hinzufügen“ legt per cart/add.js in den Warenkorb, ohne zur Warenkorb-Seite zu springen.
// Ohne JavaScript geht das Formular normal an /cart/add.
(() => {
  const root = window.Shopify?.routes?.root || '/';

  const updateCount = async () => {
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      const link = document.querySelector('.header__action[href$="/cart"]');
      if (!link) return;
      let badge = link.querySelector('.header__count');
      if (!badge) {
        badge = Object.assign(document.createElement('span'), { className: 'header__count' });
        badge.setAttribute('aria-hidden', 'true');
        link.append(badge);
      }
      badge.textContent = cart.item_count;
    } catch { /* Zähler bleibt beim alten Stand, Warenkorb stimmt trotzdem */ }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-card-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const label = submit.innerHTML;
    submit.setAttribute('aria-busy', 'true');
    submit.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || '');
      submit.removeAttribute('aria-busy');
      submit.textContent = `✓ ${form.dataset.added}`;
      submit.classList.add('is-added');
      updateCount();
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(() => { submit.innerHTML = label; submit.classList.remove('is-added'); submit.disabled = false; }, 2000);
    } catch (error) {
      submit.removeAttribute('aria-busy');
      submit.disabled = false;
      submit.title = error.message || form.dataset.error;
      alert(error.message || form.dataset.error);
    }
  });
})();
